export default __webpack_public_path__ + "static/media/enterprise-dynamic-20221013.254d1e3b.png";